const PersistenceConfig = require('./persistence-config');

const internals = {};

module.exports = {
    initialize
};

function initialize() {

    const persistentStorage = typeof globalThis !== 'undefined' ? globalThis.localStorage : null;
    const sessionStorage = typeof globalThis !== 'undefined' ? globalThis.sessionStorage : null;

    return {
        persistentMigrated: internals.migrateStorage({
            storage: persistentStorage,
            versionKey: PersistenceConfig.keys.persistentVersion,
            migrationField: 'persist',
            removalField: 'removePersist'
        }),
        sessionMigrated: internals.migrateStorage({
            storage: sessionStorage,
            versionKey: PersistenceConfig.keys.sessionVersion,
            migrationField: 'session',
            removalField: 'removeSession'
        })
    };
}

internals.migrateStorage = ({ migrationField, removalField, storage, versionKey }) => {

    if (!storage) {
        return false;
    }

    try {
        const storedVersion = Number(JSON.parse(storage.getItem(versionKey) || '0')) || 0;

        if (storedVersion >= PersistenceConfig.currentVersion) {
            return false;
        }

        PersistenceConfig.migrations
            .filter(({ version }) => version > storedVersion && version <= PersistenceConfig.currentVersion)
            .sort((left, right) => left.version - right.version)
            .forEach((migration) => {

                internals.migrateKeyMap(storage, migration[migrationField]);
                internals.removeKeys(storage, migration[removalField]);
            });

        storage.setItem(versionKey, JSON.stringify(PersistenceConfig.currentVersion));
        return true;
    }
    catch (err) {
        console.warn(`Unable to migrate ${migrationField} application state`, err);
        return false;
    }
};

internals.removeKeys = (storage, keys = []) => {

    keys.forEach((key) => storage.removeItem(key));
};

internals.migrateKeyMap = (storage, keyMap = {}) => {

    Object.entries(keyMap).forEach(([legacyKey, namespacedKey]) => {

        const legacyValue = storage.getItem(legacyKey);

        if (legacyValue === null) {
            return;
        }

        if (storage.getItem(namespacedKey) === null) {
            storage.setItem(namespacedKey, legacyValue);
        }

        storage.removeItem(legacyKey);
    });
};
